import { Event_ } from '../Event_';
export class AnimationEvent_ extends Event_ {
    get animationName() {
        return this.reactEvent.animationName;
    }
}
